import { Skeleton, SkeletonCircle, SkeletonPill } from "../../util/skeleton/Skeleton";

/* =============== Left Card Skeleton =============== */
export const LeftCardSkeleton = () => (
  <div className="card shadow-sm border-0">
    <div className="card-body">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div style={{ flex: 1 }}>
          <div className="text-uppercase text-muted small">MAC ADDRESS</div>
          <Skeleton w="70%" h={18} />
        </div>
        <SkeletonPill w={64} h={22} />
      </div>

      <div className="d-flex align-items-center mt-3">
        <SkeletonCircle size={48} />
        <div className="ml-3" style={{ flex: 1 }}>
          <Skeleton w="40%" h={14} />
          <div className="mt-2"><Skeleton w="30%" h={12} /></div>
        </div>
      </div>

      <hr />
      <div className="mb-2">
        <div className="d-flex justify-content-between align-items-center">
          <span className="small text-muted">Nickname</span>
          <Skeleton w="38px" h={14} />
        </div>
        <div className="mt-1"><Skeleton w="60%" h={16} /></div>
        <div className="mt-1"><Skeleton w="50%" h={12} /></div>
      </div>

      <div className="row text-center mt-3">
        <div className="col-4">
          <div className="text-muted small">Sessions</div>
          <Skeleton w="36px" h={24} />
        </div>
        <div className="col-4">
          <div className="text-muted small">Download</div>
          <Skeleton w="64px" h={18} />
        </div>
        <div className="col-4">
          <div className="text-muted small">Upload</div>
          <Skeleton w="64px" h={18} />
        </div>
      </div>

      <div className="mt-3 small">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="d-flex justify-content-between mb-2">
            <span className="text-muted"><Skeleton w="80px" h={12} /></span>
            <span><Skeleton w="120px" h={12} /></span>
          </div>
        ))}
      </div>

      <div className="mt-4 p-3 rounded" style={{ background: 'linear-gradient(135deg, #1f2430, #1a1f2b)' }}>
        <Skeleton w="40%" h={12} />
        <div className="d-flex justify-content-between align-items-center mt-2">
          <div style={{ flex: 1 }}>
            <Skeleton w="60%" h={14} />
            <div className="mt-1"><Skeleton w="40%" h={12} /></div>
          </div>
          <SkeletonPill w={64} h={22} />
        </div>
      </div>
    </div>
  </div>
);

/* =============== Vouchers Table Skeleton =============== */
export const VouchersTableSkeleton = () => (
  <div className="table-responsive">
    <table className="table table-hover table-sm align-middle mb-0">
      <thead className="thead-light">
        <tr>
          {['Voucher','Plan','Amount','Purchased','Expires','Uses','Status'].map((h) => (
            <th key={h}><Skeleton w="70%" h={12} /></th>
          ))}
        </tr>
      </thead>
      <tbody>
        {[...Array(8)].map((_, i) => (
          <tr key={i}>
            <td><Skeleton w="140px" h={14} /></td>
            <td><Skeleton w="120px" h={14} /></td>
            <td><Skeleton w="80px" h={14} /></td>
            <td><Skeleton w="120px" h={14} /></td>
            <td><Skeleton w="120px" h={14} /></td>
            <td className="text-center"><Skeleton w="32px" h={14} /></td>
            <td><SkeletonPill w={64} h={20} /></td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

/* =============== Connections List Skeleton =============== */
export const ConnectionsListSkeleton = () => (
  <div className="list-group list-group-flush">
    {[...Array(5)].map((_, i) => (
      <div key={i} className="list-group-item px-0 py-3">
        <div className="d-flex justify-content-between">
          <div style={{ flex: 1 }}>
            <div className="d-flex align-items-center">
              <SkeletonPill w={70} h={20} />
              <div className="ml-2"><Skeleton w="160px" h={14} /></div>
              <div className="ml-2"><Skeleton w="90px" h={12} /></div>
            </div>
            <div className="mt-1"><Skeleton w="300px" h={12} /></div>
          </div>
          <div className="text-right" style={{ width: 120 }}>
            <Skeleton w="70px" h={12} />
            <div className="mt-1"><Skeleton w="70px" h={12} /></div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

